<script setup lang="ts">
    import {computed, ref, onMounted} from 'vue';
    import { useI18n } from 'vue-i18n';

    import CpText from '~/components/cp/CpText/CpText.vue';
    import BrandImage from '~/assets/img/WarrantyLike.svg';
    import ProviderBrandFolioRequiredImage from '~/assets/img/WarrantyShieldProvider.svg';
    import CpImage from '~/assets/img/WarrantyShieldCp.svg';


    const {t} = useI18n();

    const props = withDefaults(defineProps<{
        size?: 'small'|'large',
        kind: 'Brand'|'Cp'|'ProviderBrandFolioRequired',
        brandName?: string,
        title?: string,
    }>(), {
        size: 'small',
        kind: 'Brand',
        brandName: '',
        title: '',
    });
    const brandImage = computed(() => {
        switch (props.kind) {
            case 'Brand':
                return BrandImage;
            case 'Cp':
                return CpImage;
            case 'ProviderBrandFolioRequired':
                return ProviderBrandFolioRequiredImage;
            default:
                return '';
        }
    });

    const processTitle = computed(() => {
        if (props.title && props.title.includes('<br>')) {
            let newTitle = props.title.split('<br>');
            return newTitle;
        } else {
            return [];
        }
    });
</script>

<template>
    <span  class="cp-badge-warranty-module" :class="(size==='small')?'cp-badge-warranty-module--small':'cp-badge-warranty-module--large'">
        <img :src="brandImage"  :class="(size==='small')?'cp-badge-warranty-module__brand-image--small':'cp-badge-warranty-module__brand-image--large'" alt="Garantía gestionada" />

        <div class="cp-badge-warranty-module__message-box" v-if="!processTitle.length">
            <CpText variant="heading-h3" type="mkt-dark">
                {{t('warranty-title')}}
                <span v-if="kind === 'ProviderBrandFolioRequired'">{{t('by')}}</span>
            </CpText>
            <CpText variant="heading-h3" type="mkt-dark">
                <span v-if="kind !== 'ProviderBrandFolioRequired'">{{t('by-brand', {brandName})}}</span>
                <span v-else>{{t('auth-service')}}</span>
            </CpText>
        </div>
        <div class="cp-badge-warranty-module__message-box" v-else>
            <CpText variant="heading-h3" type="mkt-dark">
                {{ processTitle[0] }}
            </CpText>
            <CpText variant="heading-h3" type="mkt-dark">
                {{ processTitle[1] }}
            </CpText>
        </div>
    </span>
</template>
<style scoped lang="scss">
 .cp-badge-warranty-module {
    display: flex;
    align-items: center;
    gap: 12px;
}
.cp-badge-warranty-module--small {
    flex-direction: row;
    height: 64px;
    text-align: start !important;
}

.cp-badge-warranty-module--large {
    flex-direction: column;
    text-align: center !important;
}

.cp-badge-warranty-module__message-box {
    display: flex;
    flex-direction: column;
}

.cp-badge-warranty-module__brand-image {
    width: 64px;
    height: 64px;
}
.cp-badge-warranty-module__brand-image--large {
    width: 112px;
    height: 112px;
}
    
</style>
<i18n locale="es-US" lang="yaml">
    warranty-title: "Garantía gestionada"
    by: "por"
    by-brand: "por {brandName}"
    auth-service: "Centro de Servicio Especializado"
</i18n>